<template>
  <div class="about_us_container">
    <div class="about_us_box">
      <div class="content_box">
        <p>农民日报客户端，由农民日报社公司倾力打造的智慧移动媒体服务平台，运用大数据、人工智能、5G等先进技术，打通新闻资讯与政务、服务、商务的连接，不断强化内容优势，形成精准化和差异化传播，使之成为优质内容的生产者及智慧生活的服务者。</p>
        <!-- <img :src="require('@/assets/images/download.jpg')" alt="" class="download" /> -->
        <p class="link">
          <a href="javascript:;" @click="toProtocol">农民日报客户端用户协议</a>
          <br>
          <a href="javascript:;" @click="toPrivate">农民日报客户端隐私政策</a>
          <br>
          <a href="javascript:;" @click="toCopyright">农民日报社版权声明</a>
          <br>
          <a>APP备案号：京ICP备05068373号-2A</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "AboutUS",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "关于我们", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
    /* 跳转用户协议 */
    toProtocol() {
      this.$router.push("/protocol");
    },
    /* 跳转隐私政策 */
    toPrivate() {
      this.$router.push("/private");
    },
    /* 跳转版权声明 */
    toCopyright() {
      this.$router.push("/copyright");
    }
  },
  created() {
    document.title = "关于我们";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.about_us_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  .about_us_box {
    padding: 50px 0 32px;
  }
  .content_box {
    width: 65.61%;
    padding: 30px 0;
    margin: 0 auto;
    color: #1e1e1e;
    >div{
      font-size: 15.2px;
      line-height: 1.8em;
    }
    p {
      font-size: 15.2px;
      line-height: 1.8em;
      word-break: normal;
      text-align: justify;
      text-indent: 2em;
      &.link {
        line-height: 24px;
        text-indent: 0;
        margin-top: 32px;
        text-align: center;
        a {
          color: #777;
          font-size: 12px;
          text-decoration: none;
        }
      }
    }
    .download {
      display: block;
      width: 43.2%;
      margin: 30px auto 0;
    }
  }
}
</style>